import ConnectionIndicator from 'modules/stream/ui/components/full-size-control-panel/connectionIndicator';
import Dashboard from 'modules/stream/ui/components/full-size-control-panel/dashboard';
import Period from 'modules/stream/ui/components/full-size-control-panel/period';
import PopupControl from 'modules/stream/ui/components/full-size-control-panel/popupControl';
import SyncStateButton from 'modules/stream/ui/components/full-size-control-panel/syncStateButton';
import TeamPanel from 'modules/stream/ui/components/full-size-control-panel/team-panel';
import { useFetchAvailableFeature } from 'shared/hooks/fetchering/use-fetch-available-feature';
import { useQueryParam } from 'use-query-params';
import UDText from '../../../ud-ui/components/text';
import useInitOverlay from '../hooks/initializers/use-init-overlay';
import { FullSizeControlPanelWrapper, TimeAndBoards } from './styles';

function FullSizeControlPanel() {
  useInitOverlay();

  const boardId = Number(useQueryParam('boardId')[0]);

  const { data: feature, isFetching: isFeatureFetching } = useFetchAvailableFeature();

  if (!isFeatureFetching && !feature?.OBS_INTEGRATION) {
    return (
      <UDText className={'flex-center h-full w-full'} type={'headline'}>
        Нет доступа. Необходима подписку, обратитесь в поддержку.
      </UDText>
    );
  }

  return (
    <FullSizeControlPanelWrapper>
      <div className={'flex flex-row gap-4'}>
        {!boardId && <PopupControl />}
        <SyncStateButton />
        <ConnectionIndicator />
      </div>
      <TimeAndBoards className={'mt-4 gap-8'}>
        <Period className={'flex flex-wrap'} style={{ maxWidth: 270 }} />
        <Dashboard boardId={isNaN(boardId) ? undefined : boardId} className={'flex flex-wrap'} />
      </TimeAndBoards>
      <div className="mt-4 flex flex-wrap gap-8">
        <TeamPanel className="grow" teamIndex={0} />
        <TeamPanel className="grow" teamIndex={1} />
      </div>
    </FullSizeControlPanelWrapper>
  );
}

export default FullSizeControlPanel;
